import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Table
} from "reactstrap";
import swal from 'sweetalert';

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import axios from "axios";
import {base_api_url} from "variables/general.js";
import $ from "jquery";
import datepickerFactory from 'jquery-datepicker';

function getData() {

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  let urlTarget = base_api_url + '/api/v1/nc/getnotebyid?notesId=' + params.id; 
  return axios.get(urlTarget).then(res => {
    let data = res.data.response;
    localStorage.setItem("detailLogs"+params.id,JSON.stringify(data));
    $("#s_reason").val(data.reason);
    $("#s_notes").val(data.notes);
    $("#s_name").val(data.receiversname);
    $("#br_name").html(data.receiversname);
    $("#imgDownload").data("file",data.uploadedfile)
  })
}

function submitData() {

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  var date = new Date();
  var timestamp = date.toISOString();

  let requestData = JSON.parse(localStorage.getItem("detailLogs"+params.id));

  requestData["notes"]= $("#s_notes").val();
  requestData["id"]= params.id;
  requestData["receiversname"]= $("#s_name").val();
  requestData["reason"]= $("#s_reason").val();
  requestData["timestamp"]= timestamp;

  return axios.put(base_api_url + "/api/v1/nc/updatebynotesid", requestData).then(res => {
    swal("Success","Successfully update data!","success");
    setTimeout(function(){
      window.location.reload();
    },500);
  }).catch(function (error) {
    swal("Failed!", "Something went wrong!", "error");
  });
}

class GardaVettingDetail extends React.Component {
  componentDidMount(){

    datepickerFactory($);

    $(document).on("click","#imgDownload",function(e){
      e.preventDefault();
      let fileD = $(this).data("file");

      if (fileD) {
        window.open(
          fileD,
          '_blank' // <- This is what makes it open in a new window.
        );
      } else {
        alert("Document is not uploaded by coordinator.")
      }

    });

    $(document).on("click",".btn-csconfirm",function(e){
      e.preventDefault();

      $(".errorCs").remove();
      
      let notValid = 0;
      let msgval = "";
      let cv;

      $.each($('form input'), function(index, formField) {
        if ($(formField).val()==="") {
          cv = $(formField).parent().find("label").text();
          if (cv!=="") {
            msgval = cv + " is required! <br/>";
            $(formField).parent().append("<span class='errorCs'>" + msgval + "</span>");
            notValid += 1;
          }
        }
      });

      if (notValid>0) {
        //$("#msgValidation").show();
      } else {
        submitData();
      }
      
    });

    $(document).on("click",".close",function(){
      $(this).parent().parent().hide();
    });

    getData()

  }

  render() {
    return (
      <>
        <PanelHeader size="sm"
          content={
            <div className="content">
              <div className="header text-left">
                <span className="panelHeaderDesc">View and manage School logs.</span>
                <nav aria-label="breadcrumb" role="navigation">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/admin/overview">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="/admin/report/standard-report">Standard Reports</a></li>
                    <li class="breadcrumb-item"><a href="/admin/report/standard-report/school-logs">School logs</a></li>
                    <li class="breadcrumb-item active" aria-current="page" id="br_name"></li>
                  </ol>
                </nav>
              </div>
            </div>
          }
        />
        <br/>
        <div className="content">
          <Form name="formsubmit" id="formsubmit" action="/" className="form-horizontal" method="post">
            <Row>
              <Col md="3">
                <Card className="card-chart">
                  <CardBody>
                    <Table responsive>
                      <tbody>
                        <tr>
                          <td className="td-noborder">
                            <a href="#c_h_n" className="anchorItemDetail">School Logs</a>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
              <Col md="9">
                <Card id="c_h_n">
                  <CardHeader>
                    <CardTitle tag="h4" className="panelTitle">School Logs</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col sm="12">
                        <FormGroup>
                          <h4 className="subHeaderBlue">School Logs</h4>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12">
                        <Row>
                          <Col md="6">
                            <FormGroup>
                              <div class="form-floating">
                                <Input id="s_name" style={{"borderRadius": "5px"}} placeholder="ID" type="text" />
                                <label for="pwd">School Name</label>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md="6">
                            <FormGroup>
                              <div class="form-floating">
                                <Input id="s_reason" style={{"borderRadius": "5px"}} placeholder="ID" type="text" />
                                <label for="pwd">Reason</label>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12">
                        <Row>
                          <Col md={12}>
                            <FormGroup>
                              <div class="form-floating">
                                <textarea className="form-control" id="s_notes" style={{borderRadius: "5px",border: "1px solid #e3e3e3"}} placeholder="ID" type="text"></textarea>
                                <label for="pwd">Notes</label>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12">
                        <Row>
                          <Col md={12}>
                            <FormGroup>
                              <a className="btn" href="#" id="imgDownload">Download uploaded document</a>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Row>
                  <Col sm="12">
                    <div className="pull-right">
                      <button className="btn-csconfirm">Update Changes</button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </>
    );
  }
}

export default GardaVettingDetail;
